import {registerTemplateGraphNode} from "#template/template-node/register"
import {curveGeometryAttributeSetLike, curveGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {curveGeometryAttributeLike} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeLikeNode} from "#template/nodes/geometry-graph/attribute/attribute-node"
import type {CurveGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {FilterOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/filter-operator/geometry-filter-operator-node"
import {
    GeometryFilterOperatorNode,
    filterOperatorParametersSchema,
} from "#template/nodes/geometry-graph/attribute-set/filter-operator/geometry-filter-operator-node"

export type CurveGeometryFilterOperatorParameters = FilterOperatorParameters<CurveGeometryAttributeLikeNode, CurveGeometryAttributeSetLikeNode>

const definition: TemplateNodeDefinition<CurveGeometryFilterOperatorParameters> = {
    nodeClass: "CurveGeometryFilterOperator",
    validation: {
        parameters: filterOperatorParametersSchema(curveGeometryAttributeLike, curveGeometryAttributeSetLike),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class CurveGeometryFilterOperator
    extends GeometryFilterOperatorNode<1, CurveGeometryAttributeLikeNode, CurveGeometryAttributeSetLikeNode>
    implements CurveGeometryAttributeSetLikeNode
{
    get [curveGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }
}
